export const APPLICANTDOCUMENT_LOADING = "APPLICANTDOCUMENT_LOADING";
export const APPLICANTDOCUMENT_RESET = "APPLICANTDOCUMENT_RESET";
export const GET_APPLICANTDOCUMENT = "GET_APPLICANTDOCUMENT";
export const GET_APPLICANTDOCUMENT_SUCCESS = "GET_APPLICANTDOCUMENT_SUCCESS";
export const GET_APPLICANTDOCUMENT_FAIL = "GET_APPLICANTDOCUMENT_FAIL";
export const DELETE_APPLICANTDOCUMENT = "DELETE_APPLICANTDOCUMENT"
export const DELETE_APPLICANTDOCUMENT_SUCCESS = "DELETE_APPLICANTDOCUMENT_SUCCESS"
export const DELETE_APPLICANTDOCUMENT_FAIL = "DELETE_APPLICANTDOCUMENT_FAIL"
export const UPDATE_APPLICANTDOCUMENT = "UPDATE_APPLICANTDOCUMENT"
export const UPDATE_APPLICANTDOCUMENT_SUCCESS = "UPDATE_APPLICANTDOCUMENT_SUCCESS"
export const UPDATE_APPLICANTDOCUMENT_FAIL = "UPDATE_APPLICANTDOCUMENT_FAIL"
export const ADD_NEW_APPLICANTDOCUMENT = "ADD_NEW_APPLICANTDOCUMENT"
export const ADD_APPLICANTDOCUMENT_SUCCESS = "ADD_APPLICANTDOCUMENT_SUCCESS"
export const ADD_APPLICANTDOCUMENT_FAIL = "ADD_APPLICANTDOCUMENT_FAIL"